import { Environment } from './environment.interface';
import { EnvironmentTypes } from './environment-types';

export const environment: Environment = {
  production: true,
  type: EnvironmentTypes.prod,
  sentryConfig: {
    denyUrls: [
      'https://mc.yandex.ru',
      'https://www.google-analytics.com'
    ],
    dsn: 'https://a5f57291626f4f2b8a6b588ec69b7ea1@sentry.iiko.ru/5'
  },
  brandName: 'iiko',
  excludeSocial: ['facebook', 'instagram', 'whatsapp'],
  useMetric: ['ya', 'ga', 'gtag'],
  mapAPIKey: '57b5d4c1-2cda-4b94-a70d-ca69eb2f096a',
};
